export const FETCHING_ABORTED = 'Fetching aborted';
